export default {
    dayNav: {
        prevDay: 'Prethodni dan (Alt+←)',
        nextDay: 'Sljedeći dan (Alt+→)',
    },
}
